module.exports = __webpack_public_path__ + "img/2026_1.259dd7ab.webp";